import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useId } from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { EBallotSelectionLabel } from "../../services/ReviewSummary";
import { getSlateName } from "../../services/Slates";
var SummaryBox = styled("section")(function (_a) {
    var theme = _a.theme;
    return ({
        "margin": "23px 0 0",
        "padding": "21px",
        "borderRadius": "10px",
        "backgroundColor": theme.palette.lightBackground,
        "overflowWrap": "anywhere",
        "& .review-selection-total": {
            margin: "0 0 5px",
            fontSize: "30px",
            fontWeight: 600,
            letterSpacing: "-1px",
            color: theme.palette.brandColor,
        },
        "& .review-selection-seats": {
            fontSize: "16px",
            fontWeight: 400,
            letterSpacing: 0,
            color: theme.palette.customGrey.dark,
        },
        "& .review-selection-caption, & .review-selection-note": {
            margin: 0,
            fontSize: "14px",
            lineHeight: 1.55,
            color: theme.palette.customGrey.dark,
        },
        "& .review-selection-label": {
            display: "inline-flex",
            margin: "12px 0 0",
            padding: "4px 8px",
            borderRadius: "4px",
            background: theme.palette.white,
            color: theme.palette.customGrey.dark,
            fontSize: "12px",
        },
        "& .review-selection-note": {
            marginTop: "20px",
        },
    });
});
/** How many candidates the ballot holds and what it holds as a whole. */
export var ReviewSelectionSummary = function (_a) {
    var summary = _a.summary, defaultLanguage = _a.defaultLanguage;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var titleId = useId();
    var label = summary.label;
    var labelText = label.kind === EBallotSelectionLabel.SLATE && label.slate
        ? getSlateName(label.slate, i18n.language, defaultLanguage)
        : t("slates.count.".concat(label.kind));
    return (_jsxs(SummaryBox, { className: "review-selection-summary", "aria-labelledby": titleId, children: [_jsx(Typography, { className: "review-selection-title", component: "h2", id: titleId, sx: { fontSize: "16px", fontWeight: 700, margin: "0 0 16px" }, children: t("slates.review.title") }), _jsxs("p", { className: "review-selection-total", children: [summary.selected, " ", _jsx("span", { className: "review-selection-seats", children: t("slates.review.of", { seats: summary.seats }) })] }), _jsx("p", { className: "review-selection-caption", children: t("slates.review.selected") }), _jsx("span", { className: "review-selection-label review-selection-label-".concat(label.kind), children: labelText }), _jsx("p", { className: "review-selection-note", children: t("slates.review.note") })] }));
};
